export default __webpack_public_path__ + "static/media/category_image_1.f37449c1.webp";